import { ReactElement } from "react";

// Evergiving
import { NonPaymentFormConfig } from "@evergiving/common/dist/es2015/form";

// Form components
import { AfterAddressFieldLead } from "@/lib/components/AfterAddressFieldLead";
import { DonorFields } from "@/lib/components/DonorFields";

interface CaptureLeadsIndexPageProps {
  formConfig: NonPaymentFormConfig;
}

export const CaptureLeadsIndexPage = ({
  formConfig,
}: CaptureLeadsIndexPageProps): ReactElement => (
  <DonorFields formConfig={formConfig}>
    <AfterAddressFieldLead formConfig={formConfig} />
  </DonorFields>
);
